/**
 * Страница отчетов
 * ***/

const $reportsWrap = $('.js-reports-wrap');
const $reportsFilter = $('.js-reports-filter');
const $moreReportsBtn = $('.js-more-reports-btn');
const $reportsSliderWrap = $('.js-reports-slider');
const $xReportsSliderWrap = $('.js-x-reports-slider');

if ($reportsWrap.length) {
    const $reportSort = $('.js-report-sort');
    const $pageInput = $('.js-page-input');

    $reportSort.on('change', function () {
        $pageInput.val(1);
        loadReports(true);
    });

    $moreReportsBtn.on('click', function (e) {
        let currentPage = parseInt($pageInput.val());

        $pageInput.val(currentPage + 1);
        loadReports();

        e.preventDefault();
    });

    App.D.on('click', '.js-toggle-files', function (e) {
        const $currToggleItem = $(this);

        $currToggleItem.toggleClass('_showen');
        $currToggleItem.parent()
            .siblings('.reports-item__files').stop().slideToggle();

        e.preventDefault();
    });
}

/***
 * @addContent — флаг показываем добавлять контент в блок или заменить контент в блоке новым
 * */
function loadReports(withSort) {
    let $reportsItems = $('.js-reports-items');
    let basicUrl = $reportsFilter.data('basic-url') || (location.origin + location.pathname);

    basicUrl = basicUrl.indexOf('?') > 0 ? $reportsFilter.data('basic-url') + '&' : $reportsFilter.data('basic-url') + '?';
    App.H.addClass('_loading');

    $.ajax({
        url: $reportsFilter.attr('action'),
        data: $reportsFilter.serialize(),
        type: $reportsFilter.attr('method') || 'GET',
        cache: false,
        success: (response) => {
            if ($(response).find('.js-more-reports-btn').length) {
                $moreReportsBtn.show();
            } else {
                $moreReportsBtn.hide();
            }

            if ($(response).find('.js-reports-wrap').length) {
                const $newReports = $(response).find('.js-reports-item');

                if (withSort) {
                    $reportsWrap.html(``);
                }

                const $lastYearItem = $('.js-reports-title').last();
                let lastYear = $lastYearItem.html();

                $newReports.each(function () {
                    const $currReportItem = $(this);
                    const currYear = $currReportItem.data('year').toString();
                    let currReportHtml = `<div class="reports-item js-reports-item">${$currReportItem.html()}</div>`;

                    if (currYear === lastYear) {
                        $reportsItems.last().append(`${currReportHtml}`);
                    } else {
                        lastYear = currYear;

                        $reportsWrap.append(`<div class="reports-title js-reports-title title-h3">${currYear}</div>`);
                        $reportsWrap.append(`<div class="reports-items js-reports-items">${currReportHtml}</div>`);

                        $reportsItems = $('.js-reports-items');
                    }
                });

                if (window.history) {
                    history.pushState({param: 'Value'}, '', basicUrl + $reportsFilter.serialize());
                }

                App.H.removeClass('_loading');
            } else {
                console.log('Ошибка получения данных');
            }

            App.H.removeClass('_loading');
        },
        error: () => {
            console.log('Ошибка загрузки отчетов');
            App.H.removeClass('_loading');
        }
    });
}

if ($reportsSliderWrap.length) {
    genSliderReports($reportsSliderWrap);
}

function genSliderReports($slidersWraps) {
    $slidersWraps.each(function (i) {
        const $g = $(this);
        const $container = $g.closest('.js-reports-slider-wrap');
        const $prevBtn = $container.find('.js-reports-slider-prev');
        const $nextBtn = $container.find('.js-reports-slider-next');

        if ($g.find('.slide').length === 1) {
            return false;
        }

        // Возможность делать множественные галереи
        $g.addClass(`js-reports-slider-${i}`);
        $container.find('.js-reports-slider-pagination').addClass(`js-reports-slider-pagination-${i}`);
        $container.find('.js-reports-slider-prev').addClass(`js-reports-slider-prev-${i}`);
        $container.find('.js-reports-slider-next').addClass(`js-reports-slider-next-${i}`);

        // Инициализация
        const swiper = new Swiper(`.js-reports-slider-${i}`, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 50,
            threshold: 10,
            roundLengths: true,
            speed: 300,
            a11y: true,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                },
                1366: {
                    slidesPerView: 5,
                    slidesPerGroup: 5
                }
            },
            navigation: {
                nextEl: `.js-reports-slider-next-${i}`,
                prevEl: `.js-reports-slider-prev-${i}`,
            },
        });

        if ($prevBtn.length) {
            $prevBtn.on('click', function (e) {
                swiper.slidePrev();

                e.preventDefault();
            });
        }

        if ($nextBtn.length) {
            $nextBtn.on('click', function (e) {
                swiper.slideNext();

                e.preventDefault();
            });
        }
    });
}

if ($xReportsSliderWrap.length) {
    genSliderXReports($xReportsSliderWrap);
}

function genSliderXReports($slidersWraps) {
    $slidersWraps.each(function (i) {
        const $g = $(this);
        const $container = $g.closest('.js-reports-slider-wrap');
        const $prevBtn = $container.find('.js-reports-slider-prev');
        const $nextBtn = $container.find('.js-reports-slider-next');
        const $hovredSlides = $container.find('.js-x-reports-slider__slide:not(a)');

        if ($g.find('.slide').length === 1) {
            return false;
        }

        // Возможность делать множественные галереи
        $g.addClass(`js-x-reports-slider-${i}`);
        $container.find('.js-reports-slider-pagination').addClass(`js-x-reports-slider-pagination-${i}`);
        $container.find('.js-reports-slider-prev').addClass(`js-x-reports-slider-prev-${i}`);
        $container.find('.js-reports-slider-next').addClass(`js-x-reports-slider-next-${i}`);

        // Инициализация
        const swiper = new Swiper(`.js-x-reports-slider-${i}`, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 16,
            threshold: 10,
            roundLengths: true,
            speed: 300,
            a11y: true,
            breakpoints: {
                580: {
                    slidesPerGroup: 2
                },
                1120: {
                    slidesPerGroup: 3
                }
            },
            navigation: {
                nextEl: `.js-x-reports-slider-next-${i}`,
                prevEl: `.js-x-reports-slider-prev-${i}`,
            },
        });

        if ($prevBtn.length) {
            $prevBtn.on('click', swiper.slidePrev);
        }

        if ($nextBtn.length) {
            $nextBtn.on('click', swiper.slideNext);
        }

        $hovredSlides.each(function (i, slide) {
            const $slide = $(slide);
            const $list = $('.js-x-reports-slider__list', slide);
            let isHover = false;

            $list.slideDown().stop().hide();

            $slide.on('mouseenter', function () {
                isHover = true;
                $slide.addClass('_hover');
                $list.slideDown();
            });

            $slide.on('mouseleave', function () {
                isHover = false;
                setTimeout(function () {
                    if (!isHover) {
                        $slide.removeClass('_hover');
                        $list.slideUp();
                    }
                }, 2000);
            });

            $list.find('.scrollbar-inner').scrollbar();
        });

    });
}


// WEBPACK FOOTER //
// ./_src/js/ReportsPage.js